<template>
      <span>{{ params.value[0] ? params.value[0].name : '' }}</span>
</template>

<script>
export default {
  name: 'CellRendererNameValue'
}
</script>
